import { create } from "zustand";
import axios from "axios";

const gameResultStore = create((set, get) => ({
    gameResult: [],
    dayTop10: [],

    fetchGameResults: async () => {
        // Fetch the game results
        const res = await axios.get("/gameresult");
        console.log("Fetched game results: ", res.data.results);
        return res.data.results;
        // Set to state
        //set({ gameResults: res.data.gameResult || [] });
    },

    // Fetch the current user’s results
    // fetchGameResults: async () => {
    //     try {
    //         const res = await axios.get(`/gameresult`, {
    //             method: "GET",
    //             credentials: "include" // needed if using cookie auth
    //         });
  
    //         set({ gameResult: res.data.results || [] });
            
    //         return res.data.results;
    //     } catch (err) {
    //         console.error("Failed to fetch user results:", err);
    //     }
    // },

    // Fetch today’s top 10 users
    fetchDayTop10: async () => {
        try {
            const res = await axios.get("/gameresult/daytop10");
            set({ dayTop10: res.data.leaderboard || [] });
            return res.data.leaderboard;
        } catch (err) {
            console.error("Failed to fetch day top 10:", err);
        }
    },

    // Submit game
    createGameResult: async (numGuesses, guessedShows) => {
        try {
            const res = await axios.post("/gameresult", { numGuesses, guessedShows });
            const newResult = res.data.gameResult;

            // Refresh user's own results
            get().fetchGameResults();

            return newResult;

        } catch (err) {
            console.error(err.response?.data?.message || err.message);
            throw err;
        }
    },

}));

export default gameResultStore;